<template>
  <div v-if="false"></div>
</template>

<script>
import { LocalStorage, copyToClipboard } from "quasar";
import * as Sentry from "@sentry/vue";
import EventBus from "src/services/event-bus";
import Utils from "src/services/helpers/utils";

export default {
  name: "GlobalEventsHandler",
  data() {
    return {};
  },
  methods: {
    async session_reset() {
      const session_guid = Utils.generateGuid();
      LocalStorage.set("dialogId", session_guid);
      await this.$store.dispatch("events/initSession", {
        session_guid: session_guid
      });
      await this.$store.dispatch("chat/resetDialog");
      EventBus.$emit("session:reset:done");
    },
    copy_to_clipboard(text) {
      copyToClipboard(text)
        .then(() => {
          this.$q.notify({
            message: "Скопировано",
            type: "positive"
          });
        })
        .catch((error) => {
          this.$q.notify({
            message: "Ошибка при копировании",
            type: "negative"
          });
          Sentry.captureException(error);
        });
    }
  },
  created() {
    EventBus.$on("session:reset", this.session_reset);
    EventBus.$on("utils:copy_to_clipboard", this.copy_to_clipboard);
  },
  beforeUnmount() {
    EventBus.$off("session:reset", this.session_reset);
    EventBus.$off("utils:copy_to_clipboard", this.copy_to_clipboard);
  }
};
</script>

<style lang='scss'>
</style>
